export default __webpack_public_path__ + "static/media/4.e7e0f3d2.png";